import React, { useState, useEffect } from 'react';
import parse, { domToReact } from 'html-react-parser';
import parseDom from 'html-dom-parser';
import './AsideLastNews.less';

export default function AsideLastNews({
  header,
  post,
  uploadedOn,
  tags,
  onHeaderClick,
}) {
  const parseOptions = {
    replace: (domNode) => {
      if (domNode.name === 'table' || domNode.name === 'figure') {
        return <></>;
      }

      const nodeData = parseDom(domNode?.data || '');
      const hasFileDownloadTag = nodeData.find(
        (node) => node?.attribs?.filedownload,
      );

      if (domNode?.attribs?.filedownload) {
        return <p>{domNode.children[0]?.data}</p>;
      }
      if (hasFileDownloadTag) {
        return <>{domToReact(nodeData, parseOptions)}</>;
      }
    },
  };

  return (
    <div className="asideLastNews">
      <div className="asideLastNews-top">
        <b
          style={{
            fontSize: '18px',
            lineHeight: '25px',
            display: 'block',
            marginRight: '15px', 
          }}
        >
          Актуальное
        </b>
        <span style={{ color: '#7F7F7F' }}>
          {uploadedOn}
        </span>
      </div>
      <div style={{ color: '#7F7F7F', marginBottom: '10px', marginTop: '10px' }}>
        {tags.map((e, i) => (
          <span key={i}>
            {i > 0 && (
              <b
                style={{
                  paddingLeft: '8px',
                  paddingRight: '8px',
                }}
              >
                ·
              </b>
            )}
            {e.name}
          </span>
        ))}
      </div>
      <div className="asideLastNews-header item-header" onClick={onHeaderClick}>
        {header}
      </div>

      <div className="news-page-aside-post">
        {parse(post, parseOptions)}
      </div>
    </div>
  );
}
